import messages from './messages';

export const WARNING = 'warning';
export const CRITICAL = 'critical';
export const STARTED = 'Iniciado';
export const PHOTOS_TAKEN = 'FotosTiradas';

const millisecondsPerDay = 24 * 60 * 60 * 1000;

const getDaysAhead = ({ dueDate, currentDate }) =>
  Math.round((currentDate - dueDate) / millisecondsPerDay);

export const isTimeBeforeNow = ({ dueDate, currentDate }) => dueDate < currentDate;

export const isDayBeforeToday = ({ dueDate, currentDate }) =>
  dueDate.toJSON().slice(0, 10) < currentDate.toJSON().slice(0, 10);

export const buildTagKind = ({ status, dueDate, currentDate }) => {
  if ([STARTED, PHOTOS_TAKEN].includes(status)) {
    return WARNING;
  }

  if (isTimeBeforeNow({ dueDate, currentDate })) {
    return CRITICAL;
  }

  return undefined;
};

export const buildTagLabel = ({ intl, status, fixed, dueDate, currentDate }) => {
  const tagLabels = {
    [STARTED]: {
      message: messages.pendingChecklist,
    },
    [PHOTOS_TAKEN]: {
      message: messages.pendingUpload,
    },
  };

  const label = tagLabels[status];

  if (label) {
    return label.message;
  }

  if (fixed && isTimeBeforeNow({ dueDate, currentDate })) {
    return messages.laterFixedPhotoSession;
  }

  if (!fixed && isDayBeforeToday({ dueDate, currentDate })) {
    const daysAhead = getDaysAhead({ dueDate, currentDate });
    return intl.formatMessage(messages.laterFlexiblePhotoSession, { daysAhead });
  }

  return undefined;
};

export const buildTags = (intl, house, status, fixed, dueDate, hasProblem = false) => {
  const tags = [];
  const currentDate = new Date();

  const statusTagLabel = buildTagLabel({ intl, status, fixed, dueDate, currentDate });
  const statusTagKind = buildTagKind({ status, dueDate, currentDate });

  if (!hasProblem && statusTagLabel && statusTagKind) {
    tags.push({
      id: 'status',
      kind: statusTagKind,
      label: statusTagLabel,
    });
  }

  if (house.forRent) {
    tags.push({
      id: 'for-rent',
      kind: 'default',
      label: messages.forRent,
    });
  }

  if (house.forSale) {
    tags.push({
      id: 'for-sale',
      kind: 'default',
      label: messages.forSale,
    });
  }

  return tags;
};
